import React, { FC } from 'react';

import { MobileErrorMessage } from 'src/apps/mobile-common/components/mobile-error-message/MobileErrorMessage';
import { ProductType } from 'src/common/interfaces/Tenant';
import {
	NO_SYNCED_SESSIONS_MSG,
	NO_SYNCED_SESSIONS_TITLE
} from 'src/common/pages/dashboards-container/errorMessages';

interface MfaErrorProps {
	isNoData?: boolean;
}

export const MfaError: FC<MfaErrorProps> = ({ isNoData }) => {
	return (
		<MobileErrorMessage
			title={NO_SYNCED_SESSIONS_TITLE}
			message={NO_SYNCED_SESSIONS_MSG}
			productType={ProductType.MOBILE_FLOW_ANALYZER}
			isNoData={isNoData}
		/>
	);
};
